import { render } from "./BackerCenterGiftCardsView.vue?vue&type=template&id=67e960f4"
import script from "./BackerCenterGiftCardsView.vue?vue&type=script&lang=js"
export * from "./BackerCenterGiftCardsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__